module.exports = __webpack_public_path__ + "media/site/images/icons/factory-icon-b3851bda525c2038741b8b5a59cd8e2b.svg";